import { Assets } from 'pixi.js';

export class AssetLoader {
  constructor(app) {
    this.app = app;
    this.sheets = {};
  }

  async loadAll(onComplete) {
    const assets = [
      { name: 'background', url: '/assets/pixi-scratch/Background/background_elements.json' },
      { name: 'basegame', url: '/assets/pixi-scratch/Basegame/basegame_assets.json' },
      { name: 'buttons', url: '/assets/pixi-scratch/Buttons/ui_buttons.json' },
      { name: 'symbols', url: '/assets/pixi-scratch/Symbols/static_symbols.json' },
      { name: 'menubtns', url: '/assets/pixi-scratch/MenuBtns/ui_assets.json' },
      { name: 'matchingicontxt', url: '/assets/pixi-scratch/Translation/MATCHING ICONS.json' },
    ];

    assets.forEach(asset => {
      Assets.add({ alias: asset.name, src: asset.url });
    });

    try {
      const loaded = await Assets.load(assets.map(a => a.name));

      assets.forEach(asset => {
        if (loaded[asset.name]) {
          this.sheets[asset.name] = loaded[asset.name];
        } else {
          this.sheets[asset.name] = null;
        }
      });

      if (onComplete) onComplete(this.sheets);
    } catch (error) {
      console.error('Error loading assets:', error);
      throw error;
    }
  }

  getSheet(name) {
    return this.sheets[name] || null;
  }

  getTexture(sheetName, frameName) {
    const sheet = this.getSheet(sheetName);
    if (!sheet) {
      return null;
    }

    const texture = sheet.textures[frameName];
    if (!texture) {
      return null;
    }

    return texture;
  }
}